import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { AgencyDataType } from 'features/Yucollect/Admin/Onboarding/Agency/types/AgencyListDataType';
import { Column } from 'features/Yucollect/utils/types';

export interface AgencyListState {
  data: AgencyDataType[];
  dataGridLoader: boolean;
  pagination: {
    limit: number;
    offset: number;
    page: number;
    pageSize: number;
  };
  totalRecords: number;
  headers: any[];
  error: string | null;
}

export interface AgencyListRequest {
  page: number;
  size: number;
  searchText: string | null;
  columns: Column[] | null;
}

export const agencyListInitState: AgencyListState = {
  data: [],
  dataGridLoader: false,
  pagination: {
    limit: 10,
    offset: 0,
    page: 1,
    pageSize: 10,
  },
  totalRecords: 0,
  error: null,
  headers: [],
};

const allocationDetailsSlice = createSlice({
  name: 'agencyList',
  initialState: agencyListInitState,
  reducers: {
    fetchAllAgencies: (state, action?: PayloadAction<any>) => {
      state.dataGridLoader = true;
    },
    fetchAllAgenciesSuccess: (state, action: PayloadAction<any>) => {
      state.data = action.payload.data;
      state.totalRecords = action.payload.totalAgency;
      state.pagination = {
        limit: 10,
        offset: (action.payload.currentPage - 1) * 10,
        page: action.payload.currentPage,
        pageSize: 10,
      };
      state.headers = action.payload.headers;
      state.dataGridLoader = false;
    },
    fetchAllAgenciesFailure: (state, action: PayloadAction<any>) => {
      state.error = action.payload;
      state.dataGridLoader = false;
    },
    getAllColumnsWithDistinctValueRequest: (
      state,
      action: PayloadAction<any>
    ) => {
      state.error = null;
    },
  },
});

export const {
  fetchAllAgencies,
  fetchAllAgenciesSuccess,
  fetchAllAgenciesFailure,
  getAllColumnsWithDistinctValueRequest,
} = allocationDetailsSlice.actions;

export default allocationDetailsSlice.reducer;
